module.exports = __webpack_public_path__ + "static/media/ingles2.d0fc9d2a.png";